<template>
  <div>
    <el-button
      type="primary"
      @click="addBanner"
      style="width: auto;"
      :disabled="bannerList.length >= limitNum"
      >添加banner（{{ bannerList.length }}/{{ limitNum }}）</el-button
    >
    <el-table
      :data="bannerList"
      v-show="bannerList.length > 0"
      class="mt16"
      style="width: 70%; border: 1px solid #eee"
    >
      <el-table-column>
        <template slot-scope="scope">
          <el-image
            class="banner-image"
            v-if="scope.row.bannerUrl"
            :src="scope.row.bannerUrl"
            :preview-src-list="[scope.row.bannerUrl]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="scope.row.goShopSetting == 0">进入店铺首页</div>
          <div v-else-if="scope.row.goShopSetting == 1">跳转指定小程序</div>
          <div v-else-if="scope.row.goShopSetting == 2">进入指定链接</div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              style="width: auto;"
              @click="moveUp(scope.row, scope.$index)"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              type="text"
              style="width: auto;"
              @click="moveDown(scope.row, scope.$index)"
              v-if="scope.$index < bannerList.length - 1"
              >下移</el-button
            >
            <el-button
              type="text"
              style="width: auto;"
              @click="editBanner(scope.row, scope.$index)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="width: auto;"
              @click="deleteBanner(scope.$index)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="isEdit ? '编辑' : '添加'"
      width="800px"
      :visible.sync="isShow"
      destroy-on-close
    >
      <el-form :model="bannerForm" ref="bannerForm" label-width="120px">
        <el-form-item label="banner图片:" prop="bannerUrl" required>
          <div class="banner-box">
            <uploadCom :imgUrl.sync="bannerForm.bannerUrl" :extensions="['.jpg','.jpeg','.png','.gif']" accept=".jpg,.png,.jpeg,.gif" :pw="690" :ph="150" :limitSize="1"/>
            <div>
              <div class="upload-tip ml8">尺寸：690px*150px</div>
              <div class="upload-tip ml8">格式：JPEG、PNG、GIF（不超过1M）</div>
            </div>
          </div>
        </el-form-item>
        <jumpLinkCom v-model="bannerForm" />
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBanner">确 定</el-button>
        <el-button @click="isShow = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadCom from "./commCustomizationSet/uploadCom.vue";
import jumpLinkCom from "./jumpLinkCom.vue";
export default {
  components: {
    uploadCom,
    jumpLinkCom,
  },
  props: {
    limitNum: {
      type: Number,
      default: 6,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      isShow: false,
      bannerForm: {
        bannerUrl: "",
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
      },
      isEdit: false,
    };
  },
  computed: {
    bannerList: {
      get() {
        return this.list;
      },
      set(val) {
        this.$emit("update:list", val);
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {
    saveBanner() {
      if (!this.bannerForm.bannerUrl) {
        this.$message.warning("请上传banner图片");
        return;
      }
      if (this.bannerForm.goShopSetting == 1 && !this.bannerForm.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.bannerForm.goShopSetting == 2) {
        if (!this.bannerForm.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.bannerForm.goShopUrl.startsWith("https://") ||
          !this.bannerForm.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      if(this.isEdit){
        this.$set(this.bannerList,this.currentIndex,{...this.bannerForm})
      } else {
        this.bannerList.push({ ...this.bannerForm });
      }
      this.isShow = false;
    },
    addBanner() {
      if (this.bannerList.length >= this.limitNum) {
        this.$message.warning(`最多只能添加${this.limitNum}个banner`);
        return;
      }

      this.isShow = true;
      this.isEdit = false;
      this.bannerForm.bannerUrl = "";
      this.bannerForm.goShopSetting = 0;
      this.bannerForm.goShopAppId = "";
      this.bannerForm.goShopUrl = "";
    },
    moveUp(row, rowIndex) {
      this.bannerList.splice(rowIndex, 1);
      this.bannerList.splice(rowIndex - 1, 0, row);
    },
    moveDown(row, rowIndex) {
      this.bannerList.splice(rowIndex, 1);
      this.bannerList.splice(rowIndex + 1, 0, row);
    },
    editBanner(row, rowIndex) {
      this.isEdit = true;
      this.isShow = true;
      this.currentIndex = rowIndex;
      this.bannerForm = { ...row };
    },
    deleteBanner(rowIndex) {
      this.bannerList.splice(rowIndex, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.banner-image {
  width: 100px;
}
.banner-box {
  display: flex;
  align-items: flex-end;
  .upload-tip {
    font-size: 14px;
    line-height: normal;
    color: #999999;
  }
}
.ml8 {
  margin-left: 8px;
}
</style>
